
import { Button } from "@/components/ui/button";
import { CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText, Share2 } from "lucide-react";
import { toast } from "@/components/ui/use-toast";

export function LegalSection() {
  const handleShareApp = async () => {
    try {
      await navigator.share({
        title: 'Check out this app!',
        text: 'I thought you might be interested in this app.',
        url: window.location.origin,
      });
    } catch (error) {
      // Fallback for desktop or unsupported browsers
      navigator.clipboard.writeText(window.location.origin);
      toast({
        title: "Link copied!",
        description: "Share the link with your friends",
      });
    }
  };

  return (
    <>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <FileText className="h-5 w-5" />
          Legal & Sharing
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid gap-4">
          <Button
            variant="outline"
            className="w-full justify-start"
            onClick={() => window.open("/terms", "_blank")}
          >
            Terms and Conditions
          </Button>
          <Button
            variant="outline"
            className="w-full justify-start"
            onClick={() => window.open("/privacy", "_blank")}
          >
            Privacy Policy
          </Button>
          <Button
            variant="outline"
            className="w-full justify-start"
            onClick={handleShareApp}
          >
            <Share2 className="mr-2 h-4 w-4" />
            Share with Friends
          </Button>
        </div>
      </CardContent>
    </>
  );
}
